import { useCommon } from '@/core/useCommon'
import { useCountdown } from '@/core/useCountdown'
import { memo, useEffect, useRef, useState } from 'react'

type Props = {
  callback: () => void
}

// 登入頁倒數計時元件
const Countdown = (props: Props) => {
  const { t, locale } = useCommon()
  const { callback } = props
  const countdown = 60 // 倒數秒數
  const countdownRef = useRef<HTMLDivElement>(null)
  const isFinishedRef = useRef(false) // 記錄倒數是否已結束

  const [refresh, setRefresh] = useState(999) // 強制刷新

  /** 倒數樣式，僅處理樣式，不用處理倒數結束 */
  useCountdown(
    (date) => {
      if (date.value <= 0) {
        isFinishedRef.current = true
        countdownRef.current?.setAttribute('data-val', t('old:reacquire'))
        countdownRef.current?.classList.add('cursor-pointer', 'hover')
        countdownRef.current?.classList.remove('pointer-events-none', 'cursor-not-allowed', 'opacity-60')
        return
      }
      isFinishedRef.current = false
      countdownRef.current?.setAttribute('data-val', String(date.value) + 'S')
    },
    {
      key: refresh,
      end: Date.now() + countdown * 1000,
      immediate: true,
    },
  )

  // 監聽語系變化：如果倒數已結束，重新設定翻譯文字
  useEffect(() => {
    if (isFinishedRef.current) {
      countdownRef.current?.setAttribute('data-val', t('old:reacquire'))
    }
  }, [locale, t]) // 當語系改變時觸發

  return (
    <div
      ref={countdownRef}
      className="rounded-38 text-12 sm:text-16 pointer-events-none flex h-28 min-w-54 items-center justify-center bg-[#0050C8] px-12 text-white opacity-60 after:relative after:z-10 after:content-[attr(data-val)] sm:bg-transparent sm:pr-22 sm:text-[#025BE8]"
      data-val=""
      onClick={() => {
        isFinishedRef.current = false
        countdownRef.current?.classList.remove('cursor-pointer', 'hover')
        countdownRef.current?.classList.add('pointer-events-none', 'cursor-not-allowed', 'opacity-60')
        setRefresh(Date.now())
        callback?.()
      }}
    />
  )
}

export default memo(Countdown)
